import React from 'react';
import { setCurrentView } from 'core/utils';
import SyncInventoryForSellerTemplate from 'themes/modules/order/pages/SyncInventoryForSellerTemplate';
import SyncInventoryForSellerViewStore from '../stores/SyncInventoryForSellerViewStore';

@setCurrentView((rootStore, componentProps) => new SyncInventoryForSellerViewStore(rootStore, componentProps), 'syncInventoryForSellerViewStore')
class SyncInventoryForSeller extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return <SyncInventoryForSellerTemplate {...this.props} />;
	}
}

export default SyncInventoryForSeller;
